module.exports = __webpack_public_path__ + "static/reasons-mobile-f0b02bdae7b8797f7c56aabbae995e46.png";